/* eslint-disable no-case-declarations */
/* eslint-disable array-callback-return */
import { TimeStampIntoHours } from "../../constant/helper/helper";
import isEmpty from "../../validation/isEmpty";
import { types } from "../type";

const initialState = {
  date: "",
  dataRange: 1,
  toDate: "",
  fromDate: "",
  locationId: "1",
  canteenError: "",
  canteenStatus: 0,
  selectedInputs: [],
  canteenResponse: "",
  dailyCanteens: null,
  canteenLoading: false,
  canteenSheetData: null,
  allCanteenRules: {}
};

const canteenReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case types.CanteenTypes.CANTEEN_SET_LOADING:
      return {
        ...state,
        canteenLoading: payload
      };
    case types.CanteenTypes.CREATE_CANTEEN_SET_LOADING:
      return {
        ...state,
        createCanteenRuleLoading: payload
      };

    case types.CanteenTypes.CANTEEN_CLEAR_ERRORS:
      return {
        ...state,
        canteenError: ""
      };
    case types.CanteenTypes.CANTEEN_GET_ERRORS:
      return {
        ...state,
        canteenLoading: false,
        canteenError: payload.data.message,
        canteenStatus: payload.status
      };
    case types.CanteenTypes.CANTEEN_CLEAR_RESULT:
      return {
        ...state,
        attendanceResponse: ""
      };
    case types.CanteenTypes.GET_DAILY_CANTEEN:
      const dailyCanteenArray = payload.data.dailyCanteen.map(
        (canteenData) => {
          const newArrayDynamic = [];
          payload.payloadData.map((selectValue) => {
            newArrayDynamic.push({
              label: selectValue.label,
              value: !isEmpty(canteenData.canteens)
                ? canteenData.canteens[selectValue.value]
                : ""
            });
          });
          const newArray = Object.assign({}, canteenData);
          if (!isEmpty(newArray.canteens)) {
            Object.entries(canteenData.canteens).forEach(
              ([key, value]) => {
                newArray[key] = value;
              }
            );
          }
          newArray.workerFullName =
            canteenData.workerFirstName +
            " " +
            canteenData.workerSurname;
          newArray.breakFastTime = TimeStampIntoHours(
            canteenData?.canteens?.breakFastTime
          );
          newArray.lunchTime = TimeStampIntoHours(
            canteenData?.canteens?.lunchTime
          );
          newArray.dinnerTime = TimeStampIntoHours(
            canteenData?.canteens?.dinnerTime
          );
          newArray.employeeId = canteenData._id;

          newArray.dataArray = newArrayDynamic;
          !isEmpty(newArray.attendances) &&
            delete newArray.attendances;
          delete newArray.workerFirstName;
          delete newArray.workerSurname;
          return newArray;
        }
      );
      return {
        ...state,
        canteenLoading: false,
        dailyCanteens: dailyCanteenArray
      };
    case types.CanteenTypes.GET_CANTEEN_SHEET:
      return {
        ...state,
        canteenLoading: false,
        canteenSheetData: payload.data.canteenSheet
      };
    case types.CanteenTypes.CREATE_CANTEEN_RULE:
      return {
        ...state,
        createCanteenRuleLoading: false,
        canteenResponse: payload.message
      };
    case types.CanteenTypes.GET_CANTEEN_RULE:
      return {
        ...state,
        canteenLoading: false,
        allCanteenRules: payload.data.canteenRules
      };
    case types.CanteenTypes.CANTEEN_UNMOUNT:
      return {
        ...state,
        date: "",
        toDate: "",
        fromDate: "",
        locationId: "",
        canteenError: "",
        canteenStatus: "",
        dailyCanteens: null
      };
    case types.CanteenTypes.SHEET_INPUTS:
      return {
        ...state,
        fromDate: payload.fromDate,
        toDate: payload.toDate,
        locationId: payload.locationId,
        dataFormat: payload.dataFormat,
        dataRange: !isEmpty(payload.dataRange)
          ? payload.dataRange
          : state.dataRange
      };
    case types.CanteenTypes.DAILY_ATT_INPUTS:
      return {
        ...state,
        date: payload.date,
        locationId: payload.locationId,
        selectedInputs: payload.selectedCategory
      };
    default:
      return state;
  }
};

export default canteenReducer;
